<template>
  <div>
    <TextInput
      label="First Name"
      placeholder="Elon"
      :model-value="application.firstName"
      @update:model-value="updateField('firstName', $event)"
    />
    <TextInput
      class="mt-4"
      label="Last Name"
      placeholder="Husk"
      :model-value="application.lastName"
      @update:model-value="updateField('lastName', $event)"
    />
    <PhoneInput
      class="mt-4"
      label="Phone Number"
      placeholder="+1 (281) 330 8004"
      :model-value="application.phone"
      @update:model-value="updateField('phone', $event)"
    />
    <TextInput
      class="mt-4"
      label="Email"
      placeholder="you@example.com"
      :model-value="application.email"
      @update:model-value="updateField('email', $event)"
    />
    <TextInput
      class="mt-4"
      label="RE License Number"
      :optional="true"
      placeholder="123456"
      :model-value="application.reLicenseNumber"
      @update:model-value="updateField('reLicenseNumber', $event)"
    />
    <FileInput
      label="Resume"
      :optional="true"
      limits="any Document"
      :model-value="application.resume"
      accept=".pdf, .doc, .docx"
      @update:model-value="updateField('resume', $event)"
    />
    <CheckboxInput
      class="mt-4"
      description="I consent to receive text messages at the phone number provided regarding this application. Msg & data rates may apply. Msg frequency varies. Reply HELP for help. Reply STOP to unsubscribe."
      :model-value="application.contactMethodsOptIn"
      @update:model-value="updateField('contactMethodsOptIn', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      application: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        reLicenseNumber: '',
        resume: '',
        contactMethodsOptIn: false,
      },
    };
  },
  watch: {
    modelValue: {
      handler(val) {
        if (val) {
          this.application = { ...val };
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.emitUpdate();
  },
  methods: {
    updateField(field, value) {
      this.application[field] = value;
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update:modelValue', { ...this.application });
      this.$emit('form-valid', this.isFormValid());
    },
    isFormValid() {
      if (!this.application.firstName || this.application.firstName.trim() === '') return false;
      if (!this.application.lastName || this.application.lastName.trim() === '') return false;
      if (!this.application.phone || this.application.phone.trim() === '') return false;
      if (!this.application.email || this.application.email.trim() === '') return false;
      return true;
    },
    validate() {
      return this.isFormValid();
    },
    validateForm() {
      return this.validate();
    },
  },
};
</script>
